import React from "react";
import short from "short-uuid";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  appendOverridesArray,
  subtractOverridesArray,
} from "../../../../../../redux/actions/single-contact-list";
import { Label } from "../../../../../library/label";
import "./style.scss";

const Index = ({ title }) => {
  const dispatch = useDispatch();

  const selections = [
    {
      title: "Persondetaljer",
      opts: [
        { title: "Fornavn", parent: "general", key: "firstName" },
        { title: "Etternavn", parent: "general", key: "lastName" },
      ],
    },
    {
      title: "Kontaktpunkter",
      opts: [
        { title: "E-post", parent: "contact", key: "email" },
        { title: "Telefon", parent: "contact", key: "phone" },
        { title: "Hjemmeside", parent: "contact", key: "website" },
      ],
    },
    {
      title: "Bedrift",
      opts: [
        { title: "Navn", parent: "company", key: "name" },
        { title: "Stilling", parent: "company", key: "position" },
      ],
    },
    {
      title: "Sosiale medier",
      opts: [
        { title: "Facebook", parent: "social", key: "facebook" },
        { title: "Twitter", parent: "social", key: "twitter" },
      ],
    },
    {
      title: "Addresse",
      opts: [
        { title: "Gate", parent: "address", key: "street" },
        { title: "Postnummer", parent: "address", key: "postalCode" },
        { title: "Poststed", parent: "address", key: "city" },
        { title: "Land", parent: "address", key: "country" },
      ],
    },
  ];

  const handleSelection = (key, value, parent) => {
    if (value) {
      dispatch(
        appendOverridesArray({ key: key, value: value, parent: parent })
      );
    } else {
      dispatch(subtractOverridesArray({ key: key }));
    }
  };

  return (
    <div className="single-field-container">
      <Row className="single-field-row">
        <Col md={4} className="title-col my-auto">
          <Label version={1} weight="bold">
            {title ? title : null}
          </Label>
        </Col>
        <Col md={8} className="select-col my-auto">
          <select
            onChange={(e) =>
              handleSelection(
                title,
                e.target.value,
                e.target[e.target.selectedIndex].getAttribute("data-parent")
              )
            }
            className="type-select"
          >
            <option value={""} selected>
              Velg
            </option>
            {selections.map((option) => (
              <optgroup label={option.title}>
                {option.opts.map((opt) => (
                  <option data-parent={opt.parent} value={opt.key}>
                    {opt.title}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
